import { render, staticRenderFns } from "./MergeItem.vue?vue&type=template&id=453ccebf"
import script from "./MergeItem.vue?vue&type=script&lang=js"
export * from "./MergeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports